import { render, staticRenderFns } from "./inventory-add-product.vue?vue&type=template&id=4db7c334&scoped=true&"
import script from "./inventory-add-product.vue?vue&type=script&lang=js&"
export * from "./inventory-add-product.vue?vue&type=script&lang=js&"
import style0 from "./inventory-add-product.vue?vue&type=style&index=0&id=4db7c334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7c334",
  null
  
)

export default component.exports